/**
 * 点検のお問い合わせ - 型定義
 */

/**
 * 点検ステータス
 * - received: 受付済
 * - visit_confirmed: 訪問確定済
 * - in_progress: 点検作業中
 * - result_confirmation: 点検結果確認
 * - completed: 作業完了
 */
export type InspectionStatus =
  | 'received'
  | 'visit_confirmed'
  | 'in_progress'
  | 'result_confirmation'
  | 'completed';

/**
 * ステータスの日本語表示名
 */
export const INSPECTION_STATUS_LABELS: Record<InspectionStatus, string> = {
  received: '受付済',
  visit_confirmed: '訪問確定済',
  in_progress: '点検作業中',
  result_confirmation: '点検結果確認',
  completed: '作業完了',
};

/**
 * 点検対象項目
 */
export interface InspectionItem {
  category: string;
  location: string;
}

/**
 * 点検のお問い合わせ情報
 */
export interface Inspection {
  id: number;
  status: InspectionStatus;
  requestDate: string;
  visitDate: string;
  inspectionItems?: InspectionItem[];
  contractor?: string;
  receptionManager?: string;
  manager?: string;
  inspectionResult?: string;
  resultReportUrl?: string;
}

/**
 * 点検一覧取得のレスポンス
 */
export interface InspectionListResponse {
  inspections: Inspection[];
}

/**
 * 点検詳細取得のレスポンス
 */
export interface InspectionDetailResponse {
  inspection: Inspection;
}
